"use client";

import { CurvedRowList } from "@/components/feature/curved-row-list";
import { ShowcaseTile } from "@/components/feature/showcase-tile";
import type { CurvedRowDirection } from "@/lib/curved-row-layout";
import type { PageOriginContext } from "@/lib/page-origin-context";
import { GameSize } from "@/types/game";
import type { ShowcaseGridDisplayItem } from "@/types/showcase-grid";

interface CurvedRowProps {
  items: ShowcaseGridDisplayItem[];
  direction?: CurvedRowDirection;
  enlargeMiddle?: boolean;
  sidePadding?: number;
  pageOrigin?: PageOriginContext | null;
}

/**
 * Public curved row: PLA-834 packing (mobile 6-col rearrange, desktop arc/crown).
 * Extra tiles beyond 6 are ignored. Tile size comes from the track, not game.size.
 */
export function CurvedRow({
  items,
  direction = "up",
  enlargeMiddle = true,
  sidePadding = 0,
  pageOrigin,
}: CurvedRowProps) {
  return (
    <CurvedRowList
      items={items}
      direction={direction}
      enlargeMiddle={enlargeMiddle}
      sidePadding={sidePadding}
      getKey={(item) => item.id}
      renderItem={(item) => (
        // No overflow clip: GameCard rounds its own art, and the NEW badge sits past the corner.
        <ShowcaseTile
          item={item}
          gameSize={GameSize.Small}
          pageOrigin={pageOrigin}
          previewId={item.id}
        />
      )}
    />
  );
}
